import FooterCalloutRepository from "../FooterCalloutRepository"

export default class FeatureFooterCallout extends FooterCalloutRepository {
    static schemaId = "feature_footerCallout"

    constructor() {
        super(FeatureFooterCallout.schemaId)
    }
}
